import { Injectable, inject } from '@angular/core';

interface ConsentStatus {
	analytics: boolean;
	advertising: boolean;
	necessary: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class ConsentService {
	private consentStatus: ConsentStatus = {
		analytics: false,
		advertising: false,
		necessary: true,
	};

	constructor() {
		this.loadConsentFromStorage();
	}

	initConsentBanner() {
		// Banner configuration now handled in index.html
		// This method kept for compatibility but does nothing
	}

	private loadConsentFromStorage() {
		try {
			if (typeof window !== 'undefined') {
				const stored = localStorage.getItem('cookie_consent');
				if (stored) {
					this.consentStatus = JSON.parse(stored);
				}
			}
		} catch (_error) {
			// Silent error handling
		}
	}

	getConsentStatus(): ConsentStatus {
		return { ...this.consentStatus };
	}

	isAnalyticsEnabled(): boolean {
		return this.consentStatus.analytics;
	}
}
